// extracted by mini-css-extract-plugin
export default {"homeWrapper":"home_homeWrapper__KeSar","articles":"home_articles__jzVer"};